import type { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import type { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { switchMap } from 'rxjs';

import { AuthService } from '../auth/auth.service';
import { EnvironmentService } from '../environment/environment.service';
import { apiStartsWith } from './interceptor.utils';

export const authTokenInterceptor: HttpInterceptorFn = (request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
	// Inject dependencies
	const environment = inject(EnvironmentService);

	const allowedPaths = ['/v1/profile', '/v1/order', '/v1/basket'];

	if (allowedPaths.every((startsWithPath) => !apiStartsWith(environment, request.url, startsWithPath))) return next(request);

	return inject(AuthService)
		.getAccessToken()
		.pipe(
			switchMap((accessToken) => {
				if (accessToken) {
					return next(
						request.clone({
							headers: request.headers.append('Authorization', `Bearer ${accessToken}`),
						})
					);
				}
				return next(request);
			})
		);
};
